import { constants } from 'dcmjs';
export const TransferSyntaxes = {
    IMPLICIT_VR_LITTLE_ENDIAN: constants.IMPLICIT_LITTLE_ENDIAN,
    EXPLICIT_VR_LITTLE_ENDIAN: constants.EXPLICIT_LITTLE_ENDIAN,
    DEFLATED_EXPLICIT_VR_LITTLE_ENDIAN: constants.DEFLATED_EXPLICIT_LITTLE_ENDIAN,
    EXPLICIT_VR_BIG_ENDIAN: constants.EXPLICIT_BIG_ENDIAN,
    RLE_LOSSLESS: '1.2.840.10008.1.2.5',
    MPEG2_MAIN_PROFILE_MAIN_LEVEL: '1.2.840.10008.1.2.4.100',
    MPEG2_MAIN_PROFILE_MAIN_LEVEL_FRAGMENTABLE: '1.2.840.10008.1.2.4.100.1',
    MPEG2_MAIN_PROFILE_HIGH_LEVEL: '1.2.840.10008.1.2.4.101',
    MPEG2_MAIN_PROFILE_HIGH_LEVEL_FRAGMENTABLE: '1.2.840.10008.1.2.4.101.1',
    MPEG4_AVC_H264_HIGH_PROFILE_LEVEL_4_1: '1.2.840.10008.1.2.4.102',
    MPEG4_AVC_H264_HIGH_PROFILE_LEVEL_4_1_FRAGMENTABLE: '1.2.840.10008.1.2.4.102.1',
    MPEG4_AVC_H264_BD_COMPATIBLE_HIGH_PROFILE_LEVEL_4_1: '1.2.840.10008.1.2.4.103',
    MPEG4_AVC_H264_BD_COMPATIBLE_HIGH_PROFILE_LEVEL_4_1_FRAGMENTABLE: '1.2.840.10008.1.2.4.103.1',
    MPEG4_AVC_H264_HIGH_PROFILE_LEVEL_4_2_FOR_2D_VIDEO: '1.2.840.10008.1.2.4.104',
    MPEG4_AVC_H264_HIGH_PROFILE_LEVEL_4_2_FOR_2D_VIDEO_FRAGMENTABLE: '1.2.840.10008.1.2.4.104.1',
    MPEG4_AVC_H264_HIGH_PROFILE_LEVEL_4_2_FOR_3D_VIDEO: '1.2.840.10008.1.2.4.105',
    MPEG4_AVC_H264_HIGH_PROFILE_LEVEL_4_2_FOR_3D_VIDEO_FRAGMENTABLE: '1.2.840.10008.1.2.4.105.1',
    MPEG4_AVC_H264_STEREO_HIGH_PROFILE_LEVEL_4_2: '1.2.840.10008.1.2.4.106',
    MPEG4_AVC_H264_STEREO_HIGH_PROFILE_LEVEL_4_2_FRAGMENTABLE: '1.2.840.10008.1.2.4.106.1',
    HEVC_H265_MAIN_PROFILE_LEVEL_5_1: '1.2.840.10008.1.2.4.107',
    HEVC_H265_MAIN_10_PROFILE_LEVEL_5_1: '1.2.840.10008.1.2.4.108',
};
export default TransferSyntaxes;
